export interface Story {
	id: number,
	author: string,
	headline: string,
	content: string,
	resourceType: ResourceTypes,
	linkId: number,
	dateCreated: string,
	dateModified?: string,
	tags: Tag[],
	imageFileName?: string
}

export interface Tag {
	id: number,
	name: string,
	color?: 'brand' | 'danger' | 'important' | 'informative' | 'severe' | 'subtle' | 'success' | 'warning';
}

export enum ResourceTypes {
	Game = "Game",
	Story = "Story",
	Review = "Review",
	Custom = "Custom"
}